export enum SecondSignaturePolicy {
  Optional = 'optional',
  RequiredForControlledDrugsOnly = 'required_for_controlled_drugs',
  RequiredForAllMedication = 'required_for_all_medication'
}

export type EmarSecondSignatureSettings = {
  requirement: SecondSignaturePolicy
}
